export type TemplateKind = 'Form' | 'Survey' | 'Document' | 'Checklist' | 'Request' | 'Other'

export const TEMPLATE_KINDS: TemplateKind[] = ['Form', 'Survey', 'Document', 'Checklist', 'Request', 'Other']

export interface RawTemplate {
    id: number
    title: string
    description: string
    category: string
    icon: string
    image: string
    link: string
    templateId: string
    group: string[]
    features: string[]
}

export interface Template extends RawTemplate {
    templateKind: TemplateKind
    tags: string[]
}

export const TAG_POOL = [
    'Email',
    'Payments',
    'E-signature',
    'Approval',
    'Automation',
    'Analytics',
    'Calendar',
    'Workflow',
    'Tracking',
    'Integration',
    'Security',
    'PDF',
    'Reporting',
    'Verification',
    'Notifications',
    'Multi-step',
    'Compliance',
] as const

export function deriveKind(template: Pick<RawTemplate, 'title' | 'templateId'>): TemplateKind {
    const text = `${template.title} ${template.templateId}`.toLowerCase()
    if (/\b(checklist)\b/.test(text)) return 'Checklist'
    if (/\b(survey|poll|review|assessment|feedback)\b/.test(text)) return 'Survey'
    if (/\b(request|application|approval)\b/.test(text)) return 'Request'
    if (/\b(generator|builder|creator|maker|report|invoice|contract|certificate|proposal|agreement|letter|nda|filing|disclosure|order)\b/.test(text)) return 'Document'
    if (/\b(form|wizard|module|tour|series)\b/.test(text)) return 'Form'
    return 'Other'
}

export function deriveTags(template: Pick<RawTemplate, 'title' | 'description' | 'features'>): string[] {
    const text = `${template.title} ${template.description} ${template.features.join(' ')}`.toLowerCase()
    const tags: string[] = []

    const add = (tag: string, re: RegExp) => {
        if (re.test(text) && !tags.includes(tag)) tags.push(tag)
    }

    add('Email', /email|newsletter|inbox/)
    add('Payments', /payment|invoice|billing|reimburs|pricing|currency|tax/)
    add('E-signature', /signature|e-sign|digital sign/)
    add('Approval', /approval|approve/)
    add('Automation', /automat/)
    add('Analytics', /analytic|metric|insight/)
    add('Calendar', /calendar|schedul|appointment/)
    add('Workflow', /workflow|routing/)
    add('Tracking', /tracking|track/)
    add('Integration', /integration|crm|api/)
    add('Security', /security|encryption|secure/)
    add('Compliance', /compliance|gdpr|audit|legal/)
    add('PDF', /pdf|document/)
    add('Reporting', /report/)
    add('Verification', /verification|verify|check/)
    add('Notifications', /notification|reminder|alert/)
    add('Multi-step', /multi-step|step-by-step|wizard|tour/)

    return tags.slice(0, 5)
}
